import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDteTestRequirement, IDteTestRequirementState } from "../../../types/dte/dteTestRequirementInterfaces";

const initialState: IDteTestRequirementState = {
    list: [],
    loading: false,
    error: null,
};

export const dteTestRequirementSlice = createSlice({
    name: "dteTestRequirements",
    initialState,
    reducers: {

        // ========================================
        // FETCH
        // ========================================
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },

        loadList: (state, action: PayloadAction<IDteTestRequirement[]>) => {
            state.list = action.payload;
            state.loading = false;
        },

        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
            state.loading = false;
        },

        clearList: (state) => {
            state.list = [];
        },
    },
});

export const { setLoading, loadList, setError, clearList } = dteTestRequirementSlice.actions;

export default dteTestRequirementSlice.reducer;
